import React, { useCallback, useState } from 'react'

import { number, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

let SubscriptionOverviewModal

function ProfileHeader({ locale = 'en', downloadLimit = 25 }) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalLoaded, setIsModalLoaded] = useState(false)

  function importModal() {
    if (!SubscriptionOverviewModal) {
      import('Pods/LazyLoaded/SubscriptionOverviewModal/SubscriptionOverviewModal')
        .then((module) => {
          SubscriptionOverviewModal = module.default
          setIsModalLoaded(true)
        })
        .catch((err) => {
          console.error('Failed to load SubscriptionOverviewModal:', err)
        })
    }
  }

  function handleOpenModal(e) {
    e.preventDefault()
    importModal()
    setIsModalOpen(true)
  }

  function handleCloseModal() {
    setIsModalOpen(false)
  }

  function handlePreloadModal() {
    importModal()
  }

  return (
    <div className="subscriptions-profile-header">
      <div className="content-heading">
        <h1 className="subscriptions-profile-header__title cgt-legacy-heading-h4">
          {translate('my_subscriptions.profile_header.title')}
        </h1>
        <p className="subscriptions-profile-header__description cgt-mb-0">
          {translate('my_subscriptions.profile_header.description')}

          <a
            href="#!"
            className="cgt-legacy-link cgt-ml-10"
            onClick={handleOpenModal}
            onMouseEnter={handlePreloadModal}
            onTouchStart={handlePreloadModal}
          >
            {translate('my_subscriptions.profile_header.learn_more')}
          </a>
        </p>
      </div>

      {isModalOpen && isModalLoaded && (
        <SubscriptionOverviewModal isOpen={isModalOpen} onClose={handleCloseModal} downloadLimit={downloadLimit} />
      )}
    </div>
  )
}

ProfileHeader.propTypes = {
  locale: string,
  downloadLimit: number,
}

export default ProfileHeader
